module.exports = __webpack_public_path__ + "img/report-preview.142240e0.png";